"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogTracciatoInfoCenterDtoToJSON = exports.LogTracciatoInfoCenterDtoFromJSONTyped = exports.LogTracciatoInfoCenterDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function LogTracciatoInfoCenterDtoFromJSON(json) {
    return LogTracciatoInfoCenterDtoFromJSONTyped(json, false);
}
exports.LogTracciatoInfoCenterDtoFromJSON = LogTracciatoInfoCenterDtoFromJSON;
function LogTracciatoInfoCenterDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'logOutput': !runtime_1.exists(json, 'logOutput') ? undefined : json['logOutput'],
        'exceptionLogOutput': !runtime_1.exists(json, 'exceptionLogOutput') ? undefined : json['exceptionLogOutput'],
        'nomeFile': !runtime_1.exists(json, 'nomeFile') ? undefined : json['nomeFile'],
        'numeroNdgProcessati': !runtime_1.exists(json, 'numeroNdgProcessati') ? undefined : json['numeroNdgProcessati'],
        'dataEstrazione': !runtime_1.exists(json, 'dataEstrazione') ? undefined : (new Date(json['dataEstrazione'])),
        'dataFineEstrazione': !runtime_1.exists(json, 'dataFineEstrazione') ? undefined : (json['dataFineEstrazione'] === null ? null : new Date(json['dataFineEstrazione'])),
        'numeroNdgException': !runtime_1.exists(json, 'numeroNdgException') ? undefined : json['numeroNdgException'],
    };
}
exports.LogTracciatoInfoCenterDtoFromJSONTyped = LogTracciatoInfoCenterDtoFromJSONTyped;
function LogTracciatoInfoCenterDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'logOutput': value.logOutput,
        'exceptionLogOutput': value.exceptionLogOutput,
        'nomeFile': value.nomeFile,
        'numeroNdgProcessati': value.numeroNdgProcessati,
        'dataEstrazione': value.dataEstrazione === undefined ? undefined : (value.dataEstrazione.toISOString()),
        'dataFineEstrazione': value.dataFineEstrazione === undefined ? undefined : (value.dataFineEstrazione === null ? null : value.dataFineEstrazione.toISOString()),
        'numeroNdgException': value.numeroNdgException,
    };
}
exports.LogTracciatoInfoCenterDtoToJSON = LogTracciatoInfoCenterDtoToJSON;
